/**
 !!!
 Blueprints are now stored in AuthorizeDB as resources for each org. For any new blueprint being added to this list, the steps in
 authorize/service/README.md #Adding new Blueprints/Solutions must be followed.
!!!
*/
export var BlueprintType;
(function (BlueprintType) {
    BlueprintType["PayoutOutlier"] = "payoutOutlier";
    BlueprintType["AdjustmentOutlier"] = "adjustmentOutlier";
    BlueprintType["TransactionOutlier"] = "transactionOutlier";
    BlueprintType["RevenueVsPayout"] = "revenueVsPayout";
    BlueprintType["Forecasting"] = "forecasting";
    BlueprintType["LeadScoring"] = "leadScoring";
    BlueprintType["SellerCapacity"] = "sellerCapacity";
    BlueprintType["L2ROpportunityScores"] = "l2rOpportunityScores";
    BlueprintType["SmartMatcher"] = "smartMatcher";
    BlueprintType["CombinationMatcher"] = "combinationMatcher";
    BlueprintType["ASC606Amortization"] = "asc606Amortization";
    BlueprintType["ASC606Preparation"] = "asc606Preparation";
    BlueprintType["FinancialAdvisorTurnover"] = "financialAdvisorTurnover";
    BlueprintType["CustomerLifetimeValue"] = "customerLifetimeValue";
    BlueprintType["DealValueChanges"] = "dealValueChanges";
    BlueprintType["DiscountingDiagnostics"] = "discountingDiagnostics";
    BlueprintType["OpportunityScores"] = "opportunityScores";
    BlueprintType["FuzzyMatcher"] = "fuzzyMatcher";
    BlueprintType["RosterValidation"] = "rosterValidation";
    BlueprintType["OrderConsolidation"] = "orderConsolidation";
    BlueprintType["RecordAndAdjustment"] = "recordAndAdjustment";
    BlueprintType["IdentifyNewHires"] = "identifyNewHires";
    BlueprintType["TrackTerritoryChanges"] = "trackTerritoryChanges";
    BlueprintType["TransactionReconciliation"] = "transactionReconciliation";
    BlueprintType["TransactionValidation"] = "transactionValidation";
    BlueprintType["EntityResolution"] = "entityResolution";
    BlueprintType["HierarchyCreation"] = "hierarchyCreation";
    BlueprintType["HierarchyValidator"] = "hierarchyValidator";
})(BlueprintType || (BlueprintType = {}));
export const BlueprintImagePrefix = `/blueprintImages/`;
export const BlueprintImage = {
    [BlueprintType.PayoutOutlier]: `${BlueprintImagePrefix}payoutOutlier.png`,
    [BlueprintType.AdjustmentOutlier]: `${BlueprintImagePrefix}manualAdjustmentOutlier.png`,
    [BlueprintType.TransactionOutlier]: `${BlueprintImagePrefix}transactionOutlier.png`,
    [BlueprintType.RevenueVsPayout]: `${BlueprintImagePrefix}revenueVsPayout.png`,
    [BlueprintType.Forecasting]: `${BlueprintImagePrefix}forecasting.png`,
    [BlueprintType.LeadScoring]: `${BlueprintImagePrefix}leadScoring.png`,
    [BlueprintType.SellerCapacity]: `${BlueprintImagePrefix}sellerCapacity.png`,
    [BlueprintType.L2ROpportunityScores]: `${BlueprintImagePrefix}l2rOpportunityScores.png`,
    [BlueprintType.SmartMatcher]: `${BlueprintImagePrefix}smartMatch.png`,
    [BlueprintType.CombinationMatcher]: `${BlueprintImagePrefix}combinationMatch.png`,
    [BlueprintType.ASC606Amortization]: `${BlueprintImagePrefix}asc606Amortization.png`,
    [BlueprintType.ASC606Preparation]: `${BlueprintImagePrefix}asc606Preparation.png`,
    [BlueprintType.FinancialAdvisorTurnover]: `${BlueprintImagePrefix}financialAdvisorTurnover.png`,
    [BlueprintType.CustomerLifetimeValue]: `${BlueprintImagePrefix}customerLifetimeValue.png`,
    [BlueprintType.DealValueChanges]: `${BlueprintImagePrefix}dealValueChanges.png`,
    [BlueprintType.DiscountingDiagnostics]: `${BlueprintImagePrefix}discountingDiagnostics.png`,
    [BlueprintType.OpportunityScores]: `${BlueprintImagePrefix}opportunityScores.png`,
    [BlueprintType.FuzzyMatcher]: `${BlueprintImagePrefix}fuzzyMatch.png`,
    [BlueprintType.RosterValidation]: `${BlueprintImagePrefix}rosterValidation.png`,
    [BlueprintType.OrderConsolidation]: `${BlueprintImagePrefix}orderConsolidation.png`,
    [BlueprintType.RecordAndAdjustment]: `${BlueprintImagePrefix}recordID.png`,
    [BlueprintType.IdentifyNewHires]: `${BlueprintImagePrefix}identifyNewHires.png`,
    [BlueprintType.TrackTerritoryChanges]: `${BlueprintImagePrefix}trackTerritoryChanges.png`,
    [BlueprintType.TransactionReconciliation]: `${BlueprintImagePrefix}transactionReconciliation.png`,
    [BlueprintType.TransactionValidation]: `${BlueprintImagePrefix}transactionValidation.png`,
    [BlueprintType.EntityResolution]: `${BlueprintImagePrefix}entityResolution.png`,
    [BlueprintType.HierarchyCreation]: `${BlueprintImagePrefix}hierarchyCreation.png`,
    [BlueprintType.HierarchyValidator]: `${BlueprintImagePrefix}hierarchyValidator.png`
};
//# sourceMappingURL=blueprintType.js.map